<template>
    <div :class="[
        'component',
        'component__badge_roles_list',
        lineByLine ? 'component__badge_roles_list--linebyline' : ''
    ]">
        <ul>
            <li
                v-for="(role, index) in outputRoles"
                :key="index"
            >
                <component-badge-role :role="role"></component-badge-role>
            </li>
        </ul>
        <component-button
            v-if="limitActive && roles && roles.length > limitItems"
            :name="'component-badge-roles-list-readmore-button'"
            :text="true"
            :underline="true"
            :size="'normal'"
            @click="switchReadMore"
        >{{ listExpanded ? `Show less` : `Show more` }}
        </component-button>
    </div>
</template>

<script>
import ComponentBadgeRole from '@/components/default/shared/ComponentBadgeRole'
import ComponentButton from '@/components/default/shared/ComponentButton'
export default {
  name: 'component-badge-roles-list',
  components: { ComponentButton, ComponentBadgeRole },
  data () {
    return {
      listExpanded: false
    }
  },
  props: {
    roles: {
      type: Array,
      required: true
    },
    limitActive: {
      type: Boolean,
      default: true
    },
    limitItems: {
      type: Number,
      default: 3
    },
    excludeSuperadmin: {
      type: Boolean,
      default: true
    },
    lineByLine: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    filteredRoles () {
      let roles = this.roles ? JSON.parse(JSON.stringify(this.roles)) : []

      if (this.excludeSuperadmin) {
        let rolesSuperadminIndex = roles.findIndex(obj => obj.toLowerCase() === 'superadmin')

        if (rolesSuperadminIndex > -1) {
          roles.splice(rolesSuperadminIndex, 1)
        }
      }

      return roles
    },
    outputRoles () {
      let filteredRoles = JSON.parse(JSON.stringify(this.filteredRoles))
      let rolesAsc = filteredRoles.sort()

      if (this.limitActive && !this.listExpanded && rolesAsc.length > this.limitItems) {
        rolesAsc.length = this.limitItems
      }

      return rolesAsc
    }
  },
  methods: {
    switchReadMore () {
      this.listExpanded = !this.listExpanded
    }
  }
}
</script>

<style lang="scss">
    @import "~@/assets/scss/components/default/shared/componentbadgeroleslist";
</style>
